import type { FC } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import SignupButton from '@segment/matcha/recipes/SignupButton'

const copy = {
  overline: `Partners`,
  heading: `Maximize your Facebook Ads ROI`,
  description: `Use Segment with Facebook to optimize your ad campaigns for repeatable and scalable results.`,
}

const link = {
  text: `Sign up`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroBase variant="centered">
        <CopyWrapper>
          <CopyText.Overline tag="h5" variant="textBold">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <StyledSignupButton tag="a">{link.text}</StyledSignupButton>
          </HeroRecipe.Form>
        </CopyWrapper>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.brand.segmentGreen[100]};

  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding: 0 35px 0 35px;
  }
`

const CopyWrapper = styled(HeroRecipe.Copy)`
  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    max-width: 844px;
  }
`

const StyledSignupButton = styled(SignupButton)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    width: auto;
  }
`

export default Hero
